module.exports = __webpack_public_path__ + "static/media/logo.f1b7fec6.png";